import Index from "../index/main.jsx";

export default function IndexPage() {
  return (
    <div className="index-page">
      <Index />
    </div>
  );
}
